<template>
  <div>
    <div class="home" style="">
      <div class="wrap">
        <div class="header">
          <h1 class="icon logo">
            <a class="wh100" href="javascript:;"
              ><span class="none">永恒岛M</span></a
            >
          </h1>
          <ul class="nav">
            <li class="">
              <a href="javascript:;">官網首頁<br /><i>HOME</i></a>
            </li>
            <li class="">
              <a
                href="javascript:;"
                @click="$router.push({ name: 'lingliu.policy' })"
                >隱私政策<br /><i>PRIVACY POLICY</i></a
              >
            </li>
            <li class="">
              <a
                href="javascript:;"
                @click="$router.push({ name: 'lingliu.terms' })"
                >服務條款<br /><i>Terms Of Use</i></a
              >
            </li>
          </ul>
        </div>
        <div class="clearfix section sectionA">
          <div class="center"></div>
        </div>
      </div>
      <div class="footer">
        <!-- <p>香港鈴六網絡科技有限公司</p>
            <p>Guangzhou Lulin Technology Co. LTD</p>
            <p>广州市天河区棠下荷光三横路13号301房</p> -->
        <div>
          <p>※本軟體因涉及暴力、打鬥，依遊戲軟體分級管理辦法分類為輔12級</p>
          <p>※遊戲內提供購買虛擬遊戲幣、物品等付費服務</p>
          <p>※請注意遊戲時間，避免沉迷</p>
          <p>※Lingluk Game</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import '../../../public/js/jquery.min.js'
// import '../../../public/css/home.css'
// import '../../../public/css/copy.css'
// import '../../../public/css/black.css'
// import '../../../public/js/responsiveslides.min.js'
// import '../../../public/js/lightGallery.js'
// import '../../../public/js/owl.carousel.js'
// import '../../../public/js/move-top.js'
// import '../../../public/js/easing.js'
// import '../../../public/js/bootstrap.js'
// import '../../../public/css/owl.carousel.css'
// import '../../../public/css/style.css'
// import '../../../public/css/owl.theme.css'

export default {
  mounted() {
    $('.news_title li').click(function () {
      var index = $('.news_title li').index(this)
      $('.news_title li').removeClass('on')
      $(this).addClass('on')
      $('.content .contentList').css('display', 'none').eq(index).fadeIn()
    })

    $('#focus .imgs ul').width(
      $('#focus .imgs li').length * $('#focus').width()
    )
    $('#focus .ctrl a:eq(0)').addClass('on')
    var focusT
    function focus() {
      focusT = setInterval(function () {
        var i = $('#focus .ctrl a.on').index('#focus .ctrl a') || 0,
          l = $('#focus .ctrl a').length
        i++
        if (i > l - 1) i = 0
        $('#focus .ctrl a').removeClass('on').eq(i).addClass('on')
        $('#focus .imgs ul')
          .stop(true, true)
          .animate(
            {
              left: -$('#focus').width() * i
            },
            600
          )
      }, 8000)
    }
    focus()
    //幻灯
    $('#focus .ctrl a').click(function () {
      clearInterval(focusT)
      var i = $(this).index('#focus .ctrl a')
      $('#focus .ctrl a').removeClass('on').eq(i).addClass('on')
      $('#focus .imgs ul')
        .stop(true, true)
        .animate(
          {
            left: -$('#focus').width() * i
          },
          600,
          function () {
            focus()
          }
        )
    })

    $('.sectionC .next,.sectionC .prev').click(function () {
      var i = $('.sectionC .ctrl a.on').index() || 0,
        l = $('.sectionC .ctrl a').length
      if ($(this).hasClass('next')) {
        i++
        if (i > l - 1) i = 0
      } else {
        i--
        if (i < 0) i = l - 1
      }
      $('.sectionC .ctrl a').removeClass('on').eq(i).addClass('on')
      $('.sectionC .imgs li').removeClass('on').eq(i).addClass('on')
    })
    //特色
    $('.sectionC .ctrl a').click(function () {
      var i = $(this).index()
      $('.sectionC .ctrl a').removeClass('on').eq(i).addClass('on')
      $('.sectionC .imgs li').removeClass('on').eq(i).addClass('on')
    })
    //场景
    $('#scene .ctrl a').click(function () {
      var i = $(this).index('#scene .ctrl a')
      $('#scene .ctrl a').removeClass('on').eq(i).addClass('on')
      $('#scene .imgs li').hide().eq(i).fadeIn(800)
    })
    $('.sider a').click(function () {
      var i = $(this).index()
      if (i < 4) {
        $('html,body').animate(
          { scrollTop: $('.section').eq(i).offset().top },
          500
        )
      }
    })
    function play_image_list(elementID, effect, play_time) {
      var _div = $('.' + elementID + ' ul')
      var temp_time
      if (_div.children('li').length <= 4) {
        return false
      }
      //play_img("left");
      _div.width(
        _div.children('li').length * (_div.children('li').eq(0).width() + 20)
      )
      if (effect === 'continue') {
        play_time = 30
        _div.css('margin-left', '0px')
      }
      temp_time = setTimeout(function () {
        play_img('left')
      }, play_time)
      _div.parent().hover(
        function () {
          clearTimeout(temp_time)
        },
        function () {
          temp_time = setTimeout(function () {
            play_img('left')
          }, play_time)
        }
      )

      function play_img(type) {
        if (temp_time) {
          clearTimeout(temp_time)
        }
        var div_f = $('.' + elementID + ' ul>li:first'),
          div_l = $('.' + elementID + ' ul>li:last'),
          div_width = div_f.width()
        //alert(div_width);
        if (effect === 'continue') {
          play_time = 30
          var num =
            _div[0].style.marginLeft == '0px'
              ? parseInt(_div[0].style.marginLeft)
              : parseInt(_div[0].style.marginLeft.substring(1))
          num++
          if (num <= div_width + 20) {
            _div.css('margin-left', -num + 'px')
          } else {
            _div.append(div_f)
            _div.css('margin-left', '0px')
          }
        }
        temp_time = setTimeout(function () {
          play_img('left')
        }, play_time)
        return false
      }
    }
    function minWidth() {
      var isIE6 = !-[1] && !window.XMLHttpRequest
      //if(!isIE6){return false;}
      var num = 980
      var w_width = $(window).width()
      if (w_width > num) {
        $('body').width('100%')
      } else {
        $('body').width(980)
      }
    }
    play_image_list('logs', 'continue', 4000)
    var my_jPlayer

    function scrollTxt() {
      var controls = {},
        values = {},
        t1 = 300 /*播放动画的时间*/,
        t2 = 4000 /*播放时间间隔*/,
        si
      controls.rollWrap = $('#roll-wrap')
      controls.rollWrapUl = controls.rollWrap.children()
      controls.rollWrapLIs = controls.rollWrapUl.children()
      values.liNums = controls.rollWrapLIs.length
      values.liHeight = controls.rollWrapLIs.eq(0).height()
      values.ulHeight = controls.rollWrap.height()
      this.init = function () {
        autoPlay()
        pausePlay()
      }
      /*滚动*/
      function play() {
        controls.rollWrapUl.animate(
          { 'margin-top': '-' + values.liHeight },
          t1,
          function () {
            $(this).css('margin-top', '0').children().eq(0).appendTo($(this))
          }
        )
      }

      /*自动滚动*/
      function autoPlay() {
        /*如果所有li标签的高度和大于.roll-wrap的高度则滚动*/
        if (values.liHeight * values.liNums > values.ulHeight) {
          si = setInterval(function () {
            play()
          }, t2)
        }
      }

      /*鼠标经过ul时暂停滚动*/
      function pausePlay() {
        controls.rollWrapUl.on({
          mouseenter: function () {
            clearInterval(si)
          },
          mouseleave: function () {
            autoPlay()
          }
        })
      }
    }
    new scrollTxt().init()
  }
}
</script>

<style lang='scss' scoped src='../../../public/css/home1.css'></style>
<style lang='scss' scoped src='../../../public/css/copy.css'></style>
<style lang='scss' scoped src='../../../public/css/black.css'></style>
<style lang="scss" scoped>
.sectionA {
  height: calc(100vh - 90px - 120px);
}
.footer p {
  text-align: left;
}
</style>








// WEBPACK FOOTER //
// src/route/src/lingliu/index.vue